import React from 'react';
import {
  ProjectCodeActionType,
  ProjectCodeAction,
  ProjectCodeResourceType,
} from './types';
import { ActionConfirmationDisplay } from '../types';
import { ActionConfirmationDialog } from '../ActionConfirmationDialog';

interface ConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  action: ProjectCodeActionType;
  isLoading: boolean;
  service: ProjectCodeResourceType;
}

interface DialogConfig {
  title: string;
  content: string;
  actionDisplay: ActionConfirmationDisplay;
}

const getDialogConfig = (
  action: ProjectCodeActionType,
  service: ProjectCodeResourceType,
): DialogConfig => {
  switch (service) {
    case 'all': {
      const actionDisplays: Record<
        ProjectCodeAction,
        ActionConfirmationDisplay
      > = {
        start: { text: 'Start', color: 'primary' },
        stop: { text: 'Stop', color: 'secondary' },
        restart: { text: 'Restart', color: 'primary' },
      };
      const actionDisplay = actionDisplays[action as ProjectCodeAction];
      const title = `Confirm ${actionDisplay.text} All`;
      const content = `Are you sure you want to ${actionDisplay.text.toLowerCase()} All?`;
      return { title, content, actionDisplay };
    }
    default: {
      return {
        title: 'Confirm',
        content: `Are you sure you want to execute ${action} action?`,
        actionDisplay: { text: action, color: 'primary' },
      };
    }
  }
};

export const ProjectCodeActionConfirmationDialog: React.FC<
  ConfirmationDialogProps
> = ({ open, onClose, onConfirm, action, isLoading, service }) => {
  if (!action) {
    return null;
  }

  const { title, content, actionDisplay } = getDialogConfig(action, service);

  return (
    <ActionConfirmationDialog<ProjectCodeActionType>
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      action={action}
      isLoading={isLoading}
      actionDisplay={actionDisplay}
      title={title}
      content={content}
    />
  );
};
